import { withInstall } from '../utils';
import Iframe from './index.vue';
import './index.less';

export const TlbsIframe = withInstall(Iframe);
export default TlbsIframe;
